var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('v-app',{attrs:{"footer":""}},[(_vm.showBoiler)?_c('Header'):_vm._e(),_c('v-content',[_c('router-view')],1),(_vm.showBoiler)?_c('Footer'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }